export const getWidgetFontSizeByValue = ({
  value,
  maxSize = 100,
}: {
  value: string;
  maxSize?: number;
}) => {
  let fontSize = 13;
  if (value.length <= 5) {
    fontSize = 33;
  } else if (value.length <= 6) {
    fontSize = 24;
  } else if (value.length <= 7) {
    fontSize = 21;
  } else if (value.length <= 9) {
    fontSize = 18;
  } else if (value.length <= 11) {
    fontSize = 15;
  }
  return Math.min(fontSize, maxSize);
};
